// config/trackingConfig.js - Centralized tracking configuration

/**
 * Master Page IDs
 * Define all your page types here
 */
export const PAGE_TYPES = {
    Home: 1,
    AllReviews: 2,
    AuthorReview: 3,
    UserReview: 4,
    Review: 5,
    // BookReview: 5,
    ReviewsByCategory: 6,
    ReviewsByBook: 7,
    Magazines: 8,
    Pongal: 9,
    Diwali: 10,
    Users: 11,
    //Authors: 11,
    AuthorSeries: 12,
    Interviews: 13,
    AuthorEssays: 14,
    BookPreReleases: 15,
    BookOffers: 16,
    BookFairs: 17,
    BookReleases: 18,
    Awards: 19,
    AboutUs: 20,
    ContactUs: 21,
    BookDetails: 22,
    //Users: 23,
    // Review: 24
};

/**
 * Route Tracking Configuration
 * Maps routes to their tracking settings
 */
export const TRACKING_CONFIG = {
    '/bookreviews': {
        masterPageId: PAGE_TYPES.AllReviews,
        childPageIdParam: null,
        name: 'Book Reviews List',
        trackingEnabled: true
    },
    // id: 5
    //http://localhost:5173/bookreviews/4247/வெற்றி-வேந்தன்
    // '/bookreviews': {
    //     masterPageId: PAGE_TYPES.BookReview,
    //     childPageIdParam: null,
    //     name: 'Book Reviews List',
    //     trackingEnabled: true
    // },
    //http://localhost:5173/authorreview
    '/authorreview': {
        masterPageId: PAGE_TYPES.AuthorReview,
        childPageIdParam: null,
        name: 'Authors Review',
        trackingEnabled: true
    },
    //http://localhost:5173/userreview
    '/userreview': {
        masterPageId: PAGE_TYPES.UserReview,
        childPageIdParam: null,
        name: 'Users Review',
        trackingEnabled: true
    },
    '/review/:id/:slug': {
        masterPageId: PAGE_TYPES.Review,
        childPageIdParam: 'id',
        name: 'Review Detail',
        trackingEnabled: true
    },
    '/bookreviews/:id/:slug': {
        masterPageId: PAGE_TYPES.ReviewsByBook,
        childPageIdParam: 'id',
        name: 'Book Review Detail',
        trackingEnabled: true
    },
    // Categories
    '/category/:id/:slug': {
        masterPageId: PAGE_TYPES.ReviewsByCategory,
        childPageIdParam: 'id',
        name: 'Category Page',
        trackingEnabled: true
    },
    // http://localhost:5173/author
    '/author': {
        masterPageId: PAGE_TYPES.Users,
        childPageIdParam: null,
        name: 'Authors List',
        trackingEnabled: true
    },
    '/user/:id/:slug': {
        masterPageId: PAGE_TYPES.Users,
        childPageIdParam: 'id',
        name: 'Author Profile',
        trackingEnabled: true
    },
    '/bookprereleases': {
        masterPageId: PAGE_TYPES.BookPreReleases,
        childPageIdParam: null,
        name: 'Book PreReleases',
        trackingEnabled: true
    },
    '/bookprerelease/:id/:slug': {
        masterPageId: PAGE_TYPES.BookPreReleases,
        childPageIdParam: 'id',
        name: 'Book PreReleases',
        trackingEnabled: true
    },
    '/bookoffers': {
        masterPageId: PAGE_TYPES.BookOffers,
        childPageIdParam: null,
        name: 'Book Offers',
        trackingEnabled: true
    },
    '/bookoffer/:id/:slug': {
        masterPageId: PAGE_TYPES.BookOffers,
        childPageIdParam: 'id',
        name: 'Book Offer',
        trackingEnabled: true
    },
    '/bookfairs': {
        masterPageId: PAGE_TYPES.BookFairs,
        childPageIdParam: null,
        name: 'Book Fairs',
        trackingEnabled: true
    },
    '/bookfair/:id/:slug': {
        masterPageId: PAGE_TYPES.BookFairs,
        childPageIdParam: 'id',
        name: 'Book Fair',
        trackingEnabled: true
    },
    '/booklaunches': {
        masterPageId: PAGE_TYPES.BookReleases,
        childPageIdParam: null,
        name: 'Book Releases',
        trackingEnabled: true
    },
    '/booklaunch/:id/:slug': {
        masterPageId: PAGE_TYPES.BookReleases,
        childPageIdParam: 'id',
        name: 'Book Release',
        trackingEnabled: true
    },
    '/awards': {
        masterPageId: PAGE_TYPES.Awards,
        childPageIdParam: null,
        name: 'Book Releases',
        trackingEnabled: true
    },
    '/award/:id/:slug': {
        masterPageId: PAGE_TYPES.Awards,
        childPageIdParam: 'id',
        name: 'Book Release',
        trackingEnabled: true
    },
    '/bookdetails/:id/:slug': {
        masterPageId: PAGE_TYPES.BookDetails,
        childPageIdParam: 'id',
        name: 'Book Details',
        trackingEnabled: true
    },
    '/author-info/:authorId': {
        masterPageId: PAGE_TYPES.AUTHOR_INFO,
        childPageIdParam: 'authorId',
        name: 'Author Info',
        trackingEnabled: true
    },
    // Search
    '/search': {
        masterPageId: PAGE_TYPES.SEARCH,
        childPageIdParam: null,
        name: 'Search Results',
        trackingEnabled: true,
        // Custom handler for search queries
        customIdExtractor: (location, params) => {
            // Use query param as ID
            const searchParams = new URLSearchParams(location.search);
            const query = searchParams.get('q');
            return query ? stringToNumericId(query) : 0;
        }
    },

    // Home
    '/': {
        masterPageId: PAGE_TYPES.HOME,
        childPageIdParam: null,
        name: 'Home Page',
        trackingEnabled: true
    },

    // Admin routes (tracking disabled)
    '/admin': {
        masterPageId: 0,
        childPageIdParam: null,
        name: 'Admin',
        trackingEnabled: false
    },
    '/admin/*': {
        masterPageId: 0,
        childPageIdParam: null,
        name: 'Admin Pages',
        trackingEnabled: false
    },
};

/**
 * Helper function to find matching route config
 */
export const getTrackingConfig = (pathname) => {

    // Try exact match first
    if (TRACKING_CONFIG[pathname]) {
        return TRACKING_CONFIG[pathname];
    }

    // Try pattern match
    for (const [pattern, config] of Object.entries(TRACKING_CONFIG)) {
        if (pattern.includes(':')) {
            const regex = new RegExp(
                '^' + pattern.replace(/:\w+/g, '[^/]+') + '$'
            );
            if (regex.test(pathname)) {
                return config;
            }
        }
        if (pattern.endsWith('/*')) {
            const basePattern = pattern.slice(0, -2);
            if (pathname.startsWith(basePattern)) {
                return config;
            }
        }
    }

    return null;
};

/**
 * Convert string to numeric ID
 */
export const stringToNumericId = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return Math.abs(hash);
};

/**
 * Extract child page ID from params
 */
export const extractChildPageId = (config, location, params) => {
    if (!config || !config.trackingEnabled) {
        return 0;
    }

    // Custom ID extractor
    if (config.customIdExtractor) {
        return config.customIdExtractor(location, params);
    }

    // Standard param extraction
    if (!config.childPageIdParam) {
        return 0;
    }

    const paramValue = params[config.childPageIdParam];

    // Numeric ID
    if (paramValue && !isNaN(paramValue)) {
        return parseInt(paramValue);
    }

    // String slug
    if (paramValue && typeof paramValue === 'string') {
        return stringToNumericId(paramValue);
    }

    return 0;
};